import { DataFormatoPT } from "app/types/DataFormatoPT"
import clsx from "clsx"
import globalMU from "globalMU"
import React, { useEffect, useState } from "react"
import Legenda from "../itens-orcamento/legenda/Legenda"
import { ordenarTiposFrete } from "./funcoes"
import { ItemDadosFreteProduto } from "./ItemDadosFreteProduto"
import { DadosFreteProduto, TipoFreteDisponivel } from "./tipos"
const estilosInputs = require('app/estilos/inputs.module.scss').default
const estilosTabela = require('app/estilos/tabelas.module.scss').default
const estilosFormulario = require('app/estilos/formulario.module.scss').default
import * as R from 'ramda'
import { DataFormatoEN } from "app/types/DataFormatoEN"
import { obterChaveSelecaoTipoFrete, obterIdTipoFreteSelecionado, obterTipoFrete } from "./funcoesTiposFrete"

export type FretePorPesoCubagemProps = {
    somenteLeitura: boolean
    chaveMovimentacaoOrcamento: "CODIGO" | "REFERENCIA"
    dadosFreteProdutos: DadosFreteProduto[]
    numeroCasasDecimaisQuantidade:number
    numeroCasasDecimaisPreco:number
    totalDoFrete:number
    tiposDeFreteDisponiveis: TipoFreteDisponivel[]
    idFreteGeralSelecionado: number
    permitirSelecaoDeTipoDeFretePorItem: boolean
    exibirSomenteFreteEspecialSeHouver: boolean
    onTipoFreteModificado: (identificadorItem:number, idTipoFrete:number, ehFreteEspecial:boolean) => void
    onTipoFreteModificadoParaTodosItens: (idTipoFrete:number) => void
    onDataPrevistaModificada: (identificadorItem:number, novaData:DataFormatoEN) => void
    
}

export const FretePorPesoCubagem = (props: FretePorPesoCubagemProps) => {

    const [tipoFreteGeralSelecionado, setTipoFreteGeralSelecionado] = useState<TipoFreteDisponivel>(null)

    useEffect(() => {
        R.sum(props.dadosFreteProdutos.map(dadoFrete => dadoFrete.valorFreteUnitario))
    },[props.dadosFreteProdutos])

    const tabelaProdutos = <>
        <table className={estilosTabela.tabela}
            id="FretePorPesoCubagem-tabelaProdutos"
        >
            <thead
                id="FretePorPesoCubagem-tabelaProdutos-cabecalho"
            >
                <tr
                    id="FretePorPesoCubagem-tabelaProdutos-cabecalho-linha"
                >
                    <th>
                        {props.chaveMovimentacaoOrcamento == "CODIGO" ? "Código" : "Referência"}
                    </th>
                    <th>
                        Descrição
                    </th>
                    <th className={estilosTabela.cabecalhoNumerico}>
                        Quantidade
                    </th>
                    <th>
                        Tipo de Frete
                    </th>
                    <th>
                        Data Prevista
                    </th>
                </tr>
            </thead>
            <tbody
                id="FretePorPesoCubagem-tabelaProdutos-corpo"
            >
                {(props.dadosFreteProdutos ?? []).map(dadosFrete => <ItemDadosFreteProduto
                    key={dadosFrete.identificadorItem}
                    somenteLeitura={props.somenteLeitura}
                    exibirSomenteFreteEspecialSeHouver={props.exibirSomenteFreteEspecialSeHouver}
                    permitirSelecaoDeTipoDeFretePorItem={props.permitirSelecaoDeTipoDeFretePorItem}
                    dadosFreteProduto={dadosFrete}
                    numeroCasasDecimaisQuantidade={props.numeroCasasDecimaisQuantidade}
                    onTipoDeFreteModificado={(idTipoFrete, ehFreteEspecial) => props.onTipoFreteModificado(dadosFrete.identificadorItem, idTipoFrete, ehFreteEspecial)} 
                    onDataPrevistaAlterada={(novaData) => props.onDataPrevistaModificada(dadosFrete.identificadorItem, novaData)}/>)}
            </tbody>
        </table>
    </>

    const totalFrete = <>
        <div className="_border-solid _rounded-sm _border-2 _p-4 _mt-8 _font-bold"
            id="FretePorPesoCubagem-totalFrete"
        >
            Total do Frete: <span>{globalMU.formatarValorNumerico(props.totalDoFrete, props.numeroCasasDecimaisPreco,true)}</span>
        </div>
    </>

    const legenda = <>
        <Legenda itens={[
            {
                nome: "Frete Especial Localizado",
                cor: "var(--mu-azul-solido, #0000FF)"
            },
            {
                nome: "Produto com Mais de Um Tipo de Frete Disponível",
                cor: "#80FF80"
            },
            {
                nome: "Frete por Faixa de Peso ou Cubagem Não Localizado ou Tipo de Frete Não Permitido para o Produto",
                cor: "#FFFF80"
            },
            {
                nome: "Inconsistência: Peso, Volume ou Método de Cálculo",
                cor: "#FF0000"
            },
            
        ]} />
    </>

    const selecaoTipoFreteParaTodosProdutos = <>{!props.somenteLeitura && 
        <div className={clsx(estilosFormulario.formulario, "_mb-8")}
            id="FretePorPesoCubagem-selecaoTipoFreteParaTodosProdutos"
        >
            <label>Tipos de Fretes Disponíveis</label>

            <select
                value={(obterChaveSelecaoTipoFrete(tipoFreteGeralSelecionado)) ?? ""}
                id="FretePorPesoCubagem-selecaoTipoFreteParaTodosProdutos"
                onChange={e => {
                    setTipoFreteGeralSelecionado(
                        obterTipoFrete(e.target.value, props.tiposDeFreteDisponiveis)
                    )
                    props.onTipoFreteModificadoParaTodosItens(obterIdTipoFreteSelecionado(e.target.value))
                }}>
                <option value=""></option>
                {R.sort(ordenarTiposFrete,props.tiposDeFreteDisponiveis).map((tipoFrete, index) => <option 
                    key={`${tipoFrete.Id}-${index}`}
                    value={obterChaveSelecaoTipoFrete(tipoFrete)}>
                    {tipoFrete.Descricao}
                </option>)}
            </select>
        </div>
        }</>

    const avisoSobreCapacidadeDeCarga = <div className="_mb-4"
        id="FretePorPesoCubagem-avisoSobreCapacidadeDeCarga"
    >
        <b>Tipo de Frete Sujeito a Disponibilidade de Capacidade de Carga Após Confirmação do Orçamento</b>
    </div>

    useEffect(() => {
        setTipoFreteGeralSelecionado(
            props.idFreteGeralSelecionado != null ? (props.tiposDeFreteDisponiveis ?? []).find(tf => tf.Id == props.idFreteGeralSelecionado) :
            null)
    }, [props.tiposDeFreteDisponiveis])

    return <>
    
        {selecaoTipoFreteParaTodosProdutos}

        {avisoSobreCapacidadeDeCarga}

        {tabelaProdutos}

        {totalFrete}

        {legenda}
    </>
}